<template>
    <div class="wuliu_wrap">
        <div class="title" style="padding-left:10px;">{{ progressInfo.kdname }}：{{ wldanhao }}</div>
        <div class="addressInfo" style="padding-left:10px;padding-bottom:10px;border-bottom:1px dashed #daf3ff;margin-bottom:10px;">
            <p><span>{{ progressInfo.receivername }}</span>&nbsp;<span>{{ progressInfo.receivertel }}</span></p>
            <p>{{ progressInfo.receiveraddress }}</p>
        </div>
        <el-timeline>
            <el-timeline-item v-for="(activity, index) in progressInfo.tracelist" :key="index" :timestamp="activity.time">
            <b>{{ activity.status }}</b>
            <p>{{ activity.description }}</p>
            </el-timeline-item>
        </el-timeline>
    </div>
</template>

<script>
import { wuliuInfo } from '@/api/manage.js'

export default {
    name: 'HelloWorld',
    props:['cartid', 'wuliudanhao'],
    data() {
        return {
            wldanhao:'',
            progressInfo: {
                kdname:'',
                receiveraddress:'',
                receivername:'',
                receivertel:'',
                tracelist:[]
            }
        }
    },
    created(){
        let vm = this;
        vm.wldanhao = vm.wuliudanhao;
    },
    mounted(){
        this.getWuliuInfo();
    },
    methods:{
        getWuliuInfo(){
            let vm = this;
            wuliuInfo({
                cartid: vm.cartid
            }).then(res=>{
                if(res.status){
                    vm.progressInfo = res.data;
                }
            }).catch(err=>{

            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/wuliu.vue